import APIService from './APIService'

const api = APIService()

export const fetchInventoryMoveLogs = payload => api.get(`/inventory/move-logs${payload.query}`)
